import { H3 } from "./typography/H3";

export const NoResults = () => (
  <div className="my-10 flex animate-in fade-in">
    <div className="max-w-md">
      <H3 className="!mb-1">No results</H3>
      <div>Work on your searching powers...</div>
    </div>
  </div>
);
